// import './FormattedInputNumber.scss';

import { InputNumber } from 'antd';
import { InputNumberProps } from 'antd/lib';

import { useUiContext } from '@/contexts/UiContext';

interface FormattedInputNumberProps extends InputNumberProps {
  allowNegative?: boolean;
  allowFloat?: boolean;
  onChange?: (e?) => void;
}

const FormattedInputNumber = (props: FormattedInputNumberProps) => {
  const { userLanguageDecimalSeparator } = useUiContext();
  const { className, allowNegative, allowFloat, onChange, min, onBlur, ...rest } = props;

  return (
    <InputNumber
      {...rest}
      className={`FormattedInputNumber ${className ? className : ''}`}
      min={allowNegative ? min : 0}
      formatter={value => {
        const formattedValue = `${value}`.replace(/(\.|,)/, userLanguageDecimalSeparator);

        return formattedValue;
      }}
      parser={value => {
        const parsedValue = `${value}`.replace(/,/g, '.');

        return parseFloat(parsedValue);
      }}
      onChange={onChange}
      onKeyUp={event => {
        if (event.key === 'Backspace') {
          if ((event.target as HTMLInputElement).value === '') {
            onChange?.(undefined);
          }
        }
      }}
      onKeyDown={event => {
        if (
          event.key === 'Enter' ||
          event.key === 'Tab' ||
          event.key === 'ArrowLeft' ||
          event.key === 'ArrowRight' ||
          event.key === 'Delete' ||
          event.key === 'Backspace'
        ) {
          return;
        }

        if (
          !(
            (allowFloat && (event.key === '.' || event.key === ',')) ||
            (event.key >= '0' && event.key <= '9') ||
            (allowNegative && event.key === '-')
          )
        ) {
          event.preventDefault();
        }
      }}
      onBlur={e => {
        const value = parseFloat(e.target.value);
        const min = props.min as number;

        if (min != undefined && value < min) {
          onChange?.(min);
        }

        onBlur?.(e);
      }}
    />
  );
};

export default FormattedInputNumber;
